import React from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { answerExitPoll } from './ExitPoll.actions';
import messages from './ExitPoll.messages';
import styles from './ExitPoll.module.css';
import { getIconFromQuestion } from './icons';
import PollAnswer from './PollAnswer';
import SpecifyOtherAnswer from './SpecifyOtherAnswer/SpecifyOtherAnswer';
import { getCountryCode } from '../../../lendingAPI/lendingAPISelector';

export const USER_DISPLAYED_ANSWERS_UK = [
    'letter',
    'search_engine',
    'word_of_mouth',
    'in_the_news',
    'radio',
    'train_or_bus_ad',
    'social_media'
];

export const USER_DISPLAYED_ANSWERS_DE = [
    'letter',
    'search_engine',
    'friend_or_press',
    'advisor',
    'email'
];

const mapStateToProps = (state) => ({
    ...state.exitPoll,
    country_code: getCountryCode(state)
});

const mapDispatchToProps = (dispatch) => ({
    answerExitPoll: (value) => dispatch(answerExitPoll(value))
});

class ExitPoll extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasAnsweredOther: false
        };
    }

    render() {
        const { value, answerExitPoll, enabled } = this.props;
        const { hasAnsweredOther } = this.state;

        if (!enabled) {
            return null;
        }

        if (value) {
            return (
                <div className={styles.ExitPoll} data-testid="exit-poll-form">
                    <div className={styles.ExitPollSavedTitle}>
                        <FormattedMessage {...messages.savedTitle} />
                    </div>
                    <div className={styles.ExitPollSavedSubText}>
                        <FormattedMessage {...messages.savedSubText} />
                    </div>
                </div>
            );
        }

        if (hasAnsweredOther) {
            return (
                <div className={styles.ExitPoll} data-testid="exit-poll-form">
                    <SpecifyOtherAnswer
                        answerExitPoll={answerExitPoll}
                        hideOtherAnswer={() =>
                            this.setState({ hasAnsweredOther: false })
                        }
                    />
                </div>
            );
        }

        const answers =
            this.props.country_code === 'de'
                ? USER_DISPLAYED_ANSWERS_DE
                : USER_DISPLAYED_ANSWERS_UK;
        return (
            <div className={styles.ExitPoll} data-testid="exit-poll-form">
                <div className={styles.ExitPollQuestion}>
                    <FormattedMessage {...messages.question} />
                </div>

                <div className={styles.ExitPollAnswers}>
                    {_.shuffle(answers).map((answerValue) => (
                        <PollAnswer
                            key={`exitPoll-${answerValue}`}
                            text={
                                <FormattedMessage {...messages[answerValue]} />
                            }
                            icon={getIconFromQuestion(answerValue)}
                            onClick={() => {
                                tracking.ampli.exitPollSelected({
                                    channelName: _.startCase(answerValue)
                                });

                                answerExitPoll({ answer: answerValue });
                            }}
                        />
                    ))}
                    <PollAnswer
                        text={<FormattedMessage {...messages.other} />}
                        icon={getIconFromQuestion('other')}
                        onClick={() => {
                            tracking.ampli.exitPollSelected({
                                channelName: 'Other'
                            });
                            this.setState({ hasAnsweredOther: true });
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExitPoll);
